export class AttachmentModel {
  id: number;
  name: string;
  contentType: string;
  url: string;
  size?: number;
}
